<template>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <input v-model="dataForm.name" type="text" class="form-control" id="name" placeholder="Nome" required="required" />
        </div>
        <div class="form-group">
            <input v-model="dataForm.email" type="email" class="form-control" id="email" placeholder="E-mail" required="required" />
       </div>
        <div class="form-group">
           <input v-model="dataForm.phone" type="phone" class="form-control" id="phone" placeholder="Telefone" />
        </div>
        <div class="form-group">
            <textarea v-model="dataForm.text" name="message" id="message" class="form-control" rows="5" cols="25" required="required" placeholder="Mensagem"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <div id="sucessUpdate" class="alert alert-success text-center" role="alert" v-show="success">Sua mensagem foi enviada com sucesso</div>
        <div id="errorFound" class="alert alert-danger text-center" role="alert" v-show="errorFound">Um erro foi encontrado. Verifique os campos do formulário</div>
        <button @click="sendContactForm()" class="btn btn-primary pull-right" v-show="!success">Enviar Mensagem</button>
      </div>
    </div>
</template>

<script>
  import contact from "../../api/contact"
  export default {
    name: "contact-form",
    data: function() {
      return {
        dataForm: {},
        errorFound: false,
        success: false
      }
    },
    methods: {
      sendContactForm(){
        this.success = false
        this.errorFound = false
        this.dataForm.subject = 'Formulário de contato'
        // this.dataForm.phone = '(14) 99999-9999'
        contact.create(this.dataForm).then((response) => {
          if(response.status == 200){
            let responseData = response.data
            for (let key in responseData) {
                alert('Campo '+key+': '+responseData[key])
                this.errorFound = true
            }
            if(!this.errorFound) this.success = true
          } else {
            this.errorFound = true
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
